/* ─────────────────────────────────────────────────────────────
   Yuklanish ekranidagi orb.

   Boot ekrani React'dan oldin ko'rinadi, shuning uchun u yerda kit
   komponentini chizib bo'lmaydi. Lekin ORBNING O'ZI kerak — konsolda
   bitta shakl bo'lishi shart. Yechim: `thinking-orbs` ning React
   qobig'ini emas, uning chizuvchi funksiyalarini olamiz va kanvasga
   qo'lda chizamiz. Ya'ni bu taqlid emas — ekranda aynan o'sha orb.

   Holat — `listening`, kitning Beacon'i bilan bir xil.
   ───────────────────────────────────────────────────────────── */
import { MODE_DRAWS, resolvePreset } from 'thinking-orbs'

const SIZE = 64 // paketning ikki tayyor o'lchamidan kattasi (sahifa markazi)

const canvas = document.getElementById('boot-orb')

if (canvas) {
  // Paketning o'zi ham shunday qiladi: 2 dan katta dpr foyda bermaydi
  const dpr = Math.min(2, window.devicePixelRatio || 1)
  canvas.width = Math.round(SIZE * dpr)
  canvas.height = Math.round(SIZE * dpr)

  const ctx = canvas.getContext('2d')
  const { mode, speed, opts } = resolvePreset('listening', SIZE)
  const draw = MODE_DRAWS[mode]

  // Mavzuni index.html React'dan oldin qo'yadi; `dark` = och siyoh
  const dark = document.documentElement.getAttribute('data-theme') === 'dark'

  const frame = (t) => {
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0)
    ctx.clearRect(0, 0, SIZE, SIZE)
    draw(ctx, SIZE, t, dark, opts)
  }

  const still = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches

  if (still) {
    // Harakat kamaytirilgan: paketdagidek bitta kadr (t = 0.6)
    frame(0.6)
  } else {
    const loop = () => {
      // React ekranni olib tashlagach tsikl ham to'xtaydi
      if (!canvas.isConnected) return
      frame(performance.now() / 1000 * speed)
      requestAnimationFrame(loop)
    }
    loop()
  }
}
